// extracted by mini-css-extract-plugin
export default {"user":"Item_user__sRw+Z","userMe":"Item_userMe__aCdNd","name":"Item_name__gMM0x","uuid":"Item_uuid__JqHQM"};